<template>
    <LayoutList>
        <template slot="header">
            <h1>Events</h1>
            <router-link :to="{ name: 'create-event' }" class="btn btn--primary" v-if="can('viewEvents')">Event Setup</router-link>
        </template>
<!--        <div class="form__group search" slot="search">-->
<!--            <label for="local-search" class="form__label">Search Members</label>-->
<!--            <input id="local-search" class="form__control search" type="search" placeholder="Search Members..."-->
<!--                   v-model="filters.query" />-->
<!--        </div>-->
        <GridEvents :filters="filters"></GridEvents>
    </LayoutList>
</template>
<script>
import { mapGetters } from 'vuex';
import LayoutList from '@layouts/LayoutList';
import GridEvents from "./Grid";

export default {
    name: 'EventList',
    components: {
        LayoutList,
        // FormControlRegion,
        GridEvents
    },
    data() {
        return {
            filters: {
                query: null,
                region: null,
            }
        }
    },
    computed: {
        ...mapGetters([
            'can',
            'members'
        ]),
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.$store.commit('modifyMembers', {
                    query: this.filters.query,
                    region: this.filters.region,
                });
            }
        }
    },

    methods: {
        load() {
            this.filters.query = this.members.query;
            this.filters.region = this.members.region;
        },

    },
    created() {
        this.load();
    }
}
</script>
